<template>
  <a-modal
          title="请输入检查结果"
          okText="确认"
          cancelText="下载"
          width="800px"
          :visible="visible"
          :confirm-loading="confirmLoading"
          @cancel="handleOk"
  >
    <template slot="footer">
      <a-button  @click="handleCancel">
        下载
      </a-button>
      <a-button type="primary" @click="handleOk">
        确认
      </a-button>
    </template>
    <a ref="downbtn" style="display:none" :href="baseApi+'mvc/common-file/downloadById?id='+this.param.picId"></a>
    <img style="max-width: 100%; max-height: 100%" :src="baseApi+'mvc/common-file/PreviewById?id='+this.param.picId" />
  </a-modal>
</template>

<script>

export default {
    name: "FormModel",
    data(){
        return {
            baseApi:window.BASE_CONFIG.VUE_APP_BASE_API
        }
    },
    props:{
        visible:{
            type:Boolean,
            default:false
        },
        param:{
            type:Object,
            default: ()=>{
                return {}
            }
        }
    },
    methods: {
        handleOk(e) {
            this.$emit("update:visible",false)
        },
        handleCancel(e) {


            this.$refs.downbtn.dispatchEvent(new MouseEvent('click'))
            // this.$refs.downbtn.click();
        },
    },
}
</script>

<style scoped lang="scss">

  /*/deep/ .ant-modal-body{*/
  /*height: 70vh;*/
  /*overflow-y: scroll;*/
  /*}*/

</style>